import { MediaType, ExternalAssetSource } from "../../../types";
import { BaseAsset } from "../../base";
import { TheBaseMeshAsset } from "../types";
import { getBlobDataFromUrl } from "../../../utils";

export class BaseTheBaseMeshAsset extends BaseAsset {
  protected asset: TheBaseMeshAsset;

  constructor(file: TheBaseMeshAsset) {
    super();
    this.asset = file;
  }

  getId(): string {
    return this.asset.id;
  }

  getName(): string {
    return this.asset.name;
  }

  setName(_name: string): void {
    // The Base Mesh assets are read-only
    console.warn('The Base Mesh assets cannot be renamed');
  }

  getMediaType() {
    return MediaType.Model3D;
  }

  getImageUrlForCard(): string {
    return this.asset.icon;
  }

  getPreviewUrl(): string {
    return this.asset.icon;
  }

  getDownloadUrl(): string {
    return this.asset.model;
  }

  async downloadFile(): Promise<{ blob: Blob; filename: string }> {
    const { blob } = await getBlobDataFromUrl(this.getDownloadUrl());
    return { blob, filename: `${this.getName()}.glb` };
  }

  async downloadFileVersion(_versionId: string): Promise<{ blob: Blob; filename: string }> {
    return Promise.reject(new Error('Versioning not supported'));
  }

  getMetadata() {
    return {
      status: 'ready',
      date: '',
      size: 0,
      license: 'CC0 License',
      authors: ['Tim Steer'],
    };
  }

  getSource(): string {
    return ExternalAssetSource.Thebasemesh;
  }
}
